/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ui_Media_Poster_AltInputs */

const en_us2_ui_media_poster_alt = /** @type {(inputs: Ui_Media_Poster_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, demonstration`)
};

const pt_br2_ui_media_poster_alt = /** @type {(inputs: Ui_Media_Poster_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, demonstração`)
};

const es_419_ui_media_poster_alt = /** @type {(inputs: Ui_Media_Poster_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, demostración`)
};

const pt_pt2_ui_media_poster_alt = /** @type {(inputs: Ui_Media_Poster_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, demonstração`)
};

const fr_fr2_ui_media_poster_alt = /** @type {(inputs: Ui_Media_Poster_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, démonstration`)
};

const de_de2_ui_media_poster_alt = /** @type {(inputs: Ui_Media_Poster_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, Demonstration`)
};

const it_it2_ui_media_poster_alt = /** @type {(inputs: Ui_Media_Poster_AltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, dimostrazione`)
};

/**
* | output |
* | --- |
* | "{name}, demonstration" |
*
* @param {Ui_Media_Poster_AltInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_media_poster_alt = /** @type {((inputs: Ui_Media_Poster_AltInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Media_Poster_AltInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_media_poster_alt(inputs)
	if (locale === "es-419") return es_419_ui_media_poster_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_media_poster_alt(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_media_poster_alt(inputs)
	if (locale === "de-DE") return de_de2_ui_media_poster_alt(inputs)
	if (locale === "it-IT") return it_it2_ui_media_poster_alt(inputs)
	return en_us2_ui_media_poster_alt(inputs)
});
export { ui_media_poster_alt as "ui-media.poster_alt" }